'use strict';

define('responsive-backgrounds',['jquery', 'opts'], function ($, as3opts) {

  var default_opts = {
    global_holder_selector: '.slider',
    image_box_selector: '.slide',
    global_holder_equal_to_image_box: false
  };
  
  /**
  * Constructor
  */
  var instance = function(received_opts) {
    var
      $global_holder,
      $image_boxes,
      opts,
      current_breakpoint = null;

    var init = function() {
      opts = $.extend(default_opts, received_opts);

      setVars();

      if(!$global_holder.length) {
        return;
      }

      windowResizeHandler();
      $(window).resize(windowResizeHandler);
    };

    var windowResizeHandler = function() {
      var new_val_current_breakpoint = as3opts.getCurrentBreakpoint();
      if(!current_breakpoint || current_breakpoint !== new_val_current_breakpoint) {
        current_breakpoint = new_val_current_breakpoint;
        updateBgs();
      }
    };

    var setVars = function() {
      $global_holder = $(opts.global_holder_selector);
      if(opts.global_holder_equal_to_image_box) {
        $image_boxes = $global_holder;
      }
      else {
        $image_boxes = $global_holder.find(opts.image_box_selector);
      }
    };

    var updateBgs = function() {
      $image_boxes.each(function() {
        updateThisBg($(this));
      });
    };

    var updateThisBg = function($img_box) {
      $img_box.css('background-image', 'url(' + $img_box.attr('data-bg-' + current_breakpoint) + ')');
    };

    init();

  };


  return instance;

});
